(() => {
  if (customElements.get('pr-pack-selector')) return;
  class PackSelector extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.hasAttribute('data-card-switch')) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-pack-link]');
        if (!option || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = this.closest('[data-world-card]');
        if (!card) return;
        event.preventDefault();
        card.querySelectorAll('.prw-card__link').forEach(link => { link.href = option.href; link.setAttribute('aria-label', option.dataset.title); });
        const image = card.querySelector('.prw-card__image');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.dataset.title; image.style.objectPosition = option.dataset.imagePosition || '50% 50%'; }
        card.querySelector('.prw-card__info h3').textContent = option.dataset.cardTitle || option.dataset.title;
        this.querySelectorAll('[data-pack-link]').forEach(link => { if (link === option) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
        this.offer(card, option);
        const badge = card.querySelector('[data-stock-badge]'); if (badge) badge.hidden = option.dataset.available === 'true';
        // Fußnote zum Sternchen: auf der Produktseite die eine Fußnote der Kaufspalte einblenden, sonst die Seitenfußnote (prFussnote).
        const note = document.querySelector('[data-main-fussnote]'); if (note && document.querySelector('[data-stern]')) note.hidden = false;
        card.dispatchEvent(new CustomEvent('pr:pack-change', {bubbles:true}));
      }, {signal:this.controller.signal});
      // Runde 6: Karten außerhalb von Serienwelt und Kategorie (z. B. „Passt schön zusammen.“ auf der Produktseite) tragen noch das ältere
      // Erst-Rendering („Sale −x %“); einmal nach der Preisregel normalisieren. In pr-collection-world und pr-category rendert Liquid bereits richtig.
      const startCard = this.closest('[data-world-card]'), startOption = this.querySelector('[data-pack-link][aria-current="true"]');
      if (startCard && startOption && !this.closest('pr-collection-world, pr-category')) { this.offer(startCard, startOption); const note = document.querySelector('[data-main-fussnote]'); if (note && startCard.querySelector('[data-stern]')) note.hidden = false; }
      this.enableSwipe();
    }
    // Runde 6 (Preisregel): Preis, Streichpreis, Sternchen und Angebots-Chip der Karte für das gewählte Pack.
    offer(card, option) {
      // Runde 6 (Preisregel, Leitstand 07.10.2026): Mehrteiler (4er, 6er, n Teile, Set) zeigen die Ersparnis in Euro als Neon-Chip und den
      // Streichpreis mit Sternchen (Summe der Einzelpreise, eine Fußnote je Seite); echte Einzelteile mit früherem Preis zeigen Prozent ohne Sternchen.
      // Kein Wort „Sale“. Gleiche Regel wie window.prCardOffer (pr-collection-world.js), damit Karten auf Serienwelt und Produktseite gleich aussehen.
      // R7: Der frühere Last-Pieces-Zweig (data-lp) ist entfernt; kein Template setzt data-lp mehr (grep, 07.10.2026). Mehrteiler sind immer Euro mit Sternchen.
      const label = option.textContent.trim(), packed = /^\d+er$/.test(label) || /Teile|Set/.test(label), summe = packed;
      const currentPrice = Number(option.dataset.price), comparePrice = Number(option.dataset.comparePrice);
      const diff = Number.isFinite(comparePrice) && comparePrice > currentPrice && currentPrice >= 0 ? comparePrice - currentPrice : 0;
      const percent = diff > 0 ? Math.floor(diff * 100 / comparePrice) : 0;
      const euro = cents => `${(cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, '')}\u202f€`;
      const price = card.querySelector('.prw-card__price');
      price.replaceChildren();
      const value = document.createElement('span'); value.textContent = option.dataset.money; price.append(value);
      if (option.dataset.compare && diff > 0) {
        const hidden = document.createElement('span'); hidden.className = 'pr-visually-hidden'; hidden.textContent = 'statt ';
        const compare = document.createElement('s'); compare.className = 'pr-streich'; compare.textContent = option.dataset.compare; price.append(hidden, compare);
        if (summe) { const star = document.createElement('span'); star.className = 'r2-stern'; star.dataset.stern = ''; star.setAttribute('aria-hidden', 'true'); star.textContent = '*'; price.append(star); }
      }
      card.dataset.price = option.dataset.price; card.dataset.available = option.dataset.available; card.dataset.discount = String(percent);
      const chip = card.querySelector('[data-pack-chip]'); if (chip) chip.textContent = /^\d+er$/.test(label) ? `${label}-Set` : label;
      const sale = card.querySelector('[data-sale-badge]');
      if (sale) {
        const show = summe ? diff > 0 : percent >= 1;
        sale.hidden = !show; delete sale.dataset.deepSale;
        sale.classList.add('pr-chip', 'pr-chip--neon');
        sale.textContent = show ? (summe ? `−${euro(diff)}` : `−${percent} %`) : '';
      }
    }
    // Mobil: auf dem Kartenbild quer wischen wechselt das Pack (links = nächstes, rechts = vorheriges). Senkrechtes Scrollen und Tippen bleiben unverändert.
    enableSwipe() {
      const card = this.closest('[data-world-card]');
      const media = card?.querySelector('.prw-card__media-wrap');
      if (!media || this.querySelectorAll('[data-pack-link]').length < 2) return;
      const signal = this.controller.signal;
      media.style.touchAction = 'pan-y pinch-zoom';
      let startX = 0, startY = 0, tracking = false, swallowClick = false;
      media.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('[data-pack-link]')) { tracking = false; return; }
        startX = event.touches[0].clientX; startY = event.touches[0].clientY; tracking = true;
      }, {passive:true, signal});
      media.addEventListener('touchend', event => {
        if (!tracking) return;
        tracking = false;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - startX, dy = touch.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        swallowClick = true; setTimeout(() => { swallowClick = false; }, 400);
        const links = [...this.querySelectorAll('[data-pack-link]')];
        const current = Math.max(0, links.findIndex(link => link.getAttribute('aria-current') === 'true'));
        const direction = dx < 0 ? 1 : -1;
        const next = links[current + direction];
        const image = card.querySelector('.prw-card__image');
        const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches && image?.animate;
        if (!next) { if (motion) image.animate([{transform:'translateX(0)'},{transform:`translateX(${-direction * 10}px)`},{transform:'translateX(0)'}], {duration:260, easing:'ease-out'}); return; }
        next.click();
        if (motion) image.animate([{transform:`translateX(${direction * 28}px)`, opacity:.35},{transform:'translateX(0)', opacity:1}], {duration:240, easing:'ease-out'});
      }, {passive:true, signal});
      media.addEventListener('touchcancel', () => { tracking = false; }, {passive:true, signal});
      // Nach einem Wischer kein versehentliches Öffnen der Produktseite.
      media.addEventListener('click', event => { if (swallowClick && !event.target.closest('[data-pack-link]')) { event.preventDefault(); event.stopPropagation(); } }, {capture:true, signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('pr-pack-selector', PackSelector);
})();

(() => {
  // Runde 6 (Preisregel): Karten ohne Pack-Umschalter außerhalb von Serienwelt und Kategorie (z. B. „Passt schön zusammen.“) zeigen im
  // älteren Erst-Rendering „Sale −x %“ oder „Du sparst x €“. Ohne das Wort „Sale“ und ohne „Du sparst“ als Neon-Chip ausgeben.
  const normalizeOffers = () => document.querySelectorAll('[data-world-card] [data-sale-badge]').forEach(badge => {
    if (badge.closest('pr-collection-world, pr-category')) return;
    const text = badge.textContent.trim(), cleaned = text.replace(/^Sale\s*/, '').replace(/^Du sparst\s*/, '−');
    if (cleaned !== text) badge.textContent = cleaned;
    badge.classList.add('pr-chip', 'pr-chip--neon');
  });
  normalizeOffers();
  if (window.prProductNavigation) return;
  window.prProductNavigation = true;
  let request, generation = 0, busy = false, historyRetry;
  const main = () => document.querySelector('pr-series-product[data-generic-product]');
  const selector = () => main()?.querySelector('pr-pack-selector, .pr-pack-switch--sets');
  const openDetails = () => {
    const target = document.getElementById('pr-product-details');
    if (!target) return;
    target.open = true;
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    target.querySelector('summary')?.focus({ preventScroll: true });
  };
  const navigate = async (href, push = true) => {
    const current = main();
    if (!current) return;
    if (current.inFlight || current.needsReview) {
      if (!push) {
        clearTimeout(historyRetry);
        historyRetry = setTimeout(() => navigate(location.href, false), 150);
      }
      return;
    }
    clearTimeout(historyRetry);
    request?.abort(); request = new AbortController();
    const turn = ++generation;
    const anchor = selector(), top = anchor?.getBoundingClientRect().top, y = window.scrollY;
    const url = new URL(href, location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    busy = true; current.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (turn !== generation) return;
      const incoming = page.querySelector('pr-series-product[data-generic-product]');
      if (!incoming?.querySelector('[name="id"]') || !page.querySelector('#pr-product-details')) throw new Error('Incomplete product');
      const replacements = ['pr-series-product[data-generic-product]', '[id$="__universe"]', '#pr-series-faq'].map(query => {
        const old = document.querySelector(query)?.closest('.shopify-section');
        const fresh = page.querySelector(query)?.closest('.shopify-section');
        if (!old || !fresh) throw new Error('Missing product section');
        return [old, document.importNode(fresh, true)];
      });
      const root = document.documentElement, prior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      replacements.forEach(([old, fresh]) => old.replaceWith(fresh));
      normalizeOffers();
      document.title = page.title;
      if (push) history.pushState({ prProduct: true }, '', url.pathname + url.search);
      const nextAnchor = selector();
      window.scrollTo({ top: top != null && nextAnchor ? window.scrollY + nextAnchor.getBoundingClientRect().top - top : y, behavior: 'instant' });
      nextAnchor?.querySelector('[aria-current="true"]')?.focus({ preventScroll: true });
      root.style.scrollBehavior = prior;
    } catch (error) {
      if (turn !== generation || error.name === 'AbortError') return;
      if (!push) { location.reload(); return; }
      current.notice(current.dataset.switchError);
    } finally {
      if (turn === generation) { busy = false; main()?.removeAttribute('aria-busy'); }
    }
  };
  document.addEventListener('submit', event => {
    if (busy && event.target.closest('pr-series-product[data-generic-product]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const details = event.target.closest('a[href="#pr-product-details"]');
    if (details) { event.preventDefault(); event.stopImmediatePropagation(); openDetails(); return; }
    const link = event.target.closest('pr-series-product[data-generic-product] pr-pack-selector a[data-pack-link], pr-series-product[data-generic-product] .pr-pack-switch--sets a');
    if (!link) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (link.getAttribute('aria-current') !== 'true' || busy) navigate(link.href);
  }, true);
  window.addEventListener('pagehide', () => { clearTimeout(historyRetry); request?.abort(); });
  window.addEventListener('popstate', () => { if (main()) navigate(location.href, false); });
  if (location.hash === '#pr-product-details') requestAnimationFrame(openDetails);
})();
